import React from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

import Menu2 from "../components/salones2/Menu2";
import Hero2 from "../components/salones2/Hero2";
import Showcase2 from "../components/salones2/Showcase2";
import Brand2 from "../components/salones2/Brand2";
import HowItWorks2 from "../components/salones2/HowItWorks2";
import Pricing2 from "../components/salones2/Pricing2";
import FAQ2 from "../components/salones2/FAQ2";
import FinalCTA2 from "../components/salones2/FinalCTA2";
import Footer2 from "../components/salones2/Footer2";

const Salon2 = () => {
	const { t } = useTranslation();

	return (
		<>
			<Helmet>
				<title>{t("salon2.seo.title")}</title>
				<meta name="description" content={t("salon2.seo.description")} />
				<meta name="keywords" content={t("salon2.seo.keywords")} />
				<link rel="canonical" href="https://applaby.com/salones" />

				<meta property="og:title" content={t("salon2.seo.ogTitle")} />
				<meta
					property="og:description"
					content={t("salon2.seo.ogDescription")}
				/>
				<meta
					property="og:image"
					content="https://applaby.com/assets/beauty/beauty-preview.png"
				/>
				<meta property="og:url" content="https://applaby.com/salones" />
				<meta property="og:type" content="website" />

				<meta name="twitter:card" content="summary_large_image" />
				<meta name="twitter:title" content={t("salon2.seo.twitterTitle")} />
				<meta
					name="twitter:description"
					content={t("salon2.seo.twitterDescription")}
				/>
				<meta
					name="twitter:image"
					content="https://applaby.com/assets/beauty/beauty-preview.png"
				/>
			</Helmet>

			<Menu2 />
			<Hero2 />
			<Showcase2 />
			<Brand2 />
			<HowItWorks2 />
			<Pricing2 />
			<FAQ2 />
			<FinalCTA2 />
			<Footer2 />
		</>
	);
};

export default Salon2;
